import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import { SEND_CONFIGS } from "../../config/sendConfigs";

const SendFirmware = () => {
  return (
    <>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <h1 className="m-0">Send Firmware</h1>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <CommonSendComponent config={SEND_CONFIGS.firmware} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SendFirmware;
